export const SHIFT_DETAILS_FOOTER_LOG_EVENT_SOURCE_UI = "shift-details-footer";
